import React from "react";
import deleteIcon from "../../img/closeIcon.svg";

const DownloadTemplateLoadingOrder = (props) => {

    const {
        isListDocLoadingOrder,
        isFileSelected,
        selectedFileName,
        nameTemplate,
        onSelectFileHandlerLoadingOrder,
        onHandlerDeleteFile
    } = props;

    return (
        <div className="download-template__download-file-container">
            <p className="download-template__download-file-label">Download template {nameTemplate}</p>
            <div className="download-template__file-add-container">
                <input
                    className="download-template__file-add-input"
                    id="fileCargo"
                    type="file"
                    accept=".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onChange={(e) => onSelectFileHandlerLoadingOrder(e)}
                />
                <label
                    htmlFor="fileCargo"
                    className="download-template__file-add-input-container"
                >
                    <div className="download-template__file-add-input-file-name-container">
                        <p
                            className={`download-template__file-add-input-file-name-text ${
                                isFileSelected &&
                                "download-template__file-add-input-file-name-text_selected"
                            }`}
                        >
                            {selectedFileName}
                        </p>
                    </div>
                    <div className="download-template__file-add-input-button">
                        <p className="download-template__file-add-input-button-text">Download</p>
                    </div>
                </label>
                </div>
            {isListDocLoadingOrder.length !== 0 && (
                <>
                    {isListDocLoadingOrder.map(el => {
                        return (
                            <div key={el.id} className="download-template__list-file">
                                <a href={el.link}>{el.fileName}</a>
                                <img onClick={() => onHandlerDeleteFile(el.id)} className="download-template__list-file-delete" src={deleteIcon} alt={'icon'} />
                            </div>
                        )
                    })}
                </>
            )}
            <div>
          </div>
        </div>
    )
}
export default DownloadTemplateLoadingOrder;